import { useReducer, useCallback } from 'react';

/** YYYY-MM-DD no fuso local — nunca usar toISOString() (UTC) para “hoje”. */
export const formatDataLocal = (date = new Date()) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

const hoje = () => formatDataLocal();

/** Disparos só entre 08–17; depois das 18h o default é amanhã. */
const dataPadraoCampanha = () => {
    const agora = new Date();
    if (agora.getHours() >= 18) {
        const amanha = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() + 1);
        return formatDataLocal(amanha);
    }
    return formatDataLocal(agora);
};

/**
 * Estado do wizard de campanha.
 *
 * Substitui os ~25 useState espalhados do arquivo antigo. O ganho concreto nao e
 * so estetico: `limparCampos()` era uma lista de 25 setters que precisava ser
 * mantida em sincronia manualmente (e ja tinha divergido — nao limpava tipoArquivo
 * nem tipoEnvio). Aqui reset e um unico `dispatch({ type: 'reset' })`.
 */
const estadoInicial = () => ({
    nome: '',
    tipoEnvio: 'whatsapp',
    canalEnvio: '',
    isChatAtendimento: false,

    tipo: '',
    funilId: '',
    funilIds: [],
    tagsIds: [],
    selectedContactLists: [],
    csvFile: null,
    isFiltroData: true,
    dataInicio: hoje(),
    dataFinal: hoje(),

    body: '',
    isFile: false,
    tipoArquivo: '',
    files: [],
    audioGravado: null,
    useTemplate: false,
    templateSelecionado: null,
    templateVariaveis: {},

    dataCampanha: dataPadraoCampanha(),
    horaCampanha: '',
    minutoCampanha: '00',
});

function reducer(state, action) {
    switch (action.type) {
        case 'set':
            return { ...state, [action.campo]: action.valor };

        case 'merge':
            return { ...state, ...action.valores };

        case 'reset':
            return { ...estadoInicial(), ...(action.valores || {}) };

        case 'setVariavelTemplate':
            return {
                ...state,
                templateVariaveis: { ...state.templateVariaveis, [action.chave]: action.valor },
            };

        // Troca de transporte: SMS nao tem template nem midia, entao limpar aqui
        // evita mandar lixo no payload se o usuario voltar atras no passo 1.
        case 'setTipoEnvio': {
            if (action.valor === 'sms') {
                return {
                    ...state,
                    tipoEnvio: 'sms',
                    useTemplate: false,
                    templateSelecionado: null,
                    templateVariaveis: {},
                    isFile: false,
                    tipoArquivo: '',
                    files: [],
                    audioGravado: null,
                };
            }
            return { ...state, tipoEnvio: 'whatsapp' };
        }

        default:
            return state;
    }
}

export default function useCampanhaForm() {
    const [form, dispatch] = useReducer(reducer, undefined, estadoInicial);

    const set = useCallback((campo, valor) => dispatch({ type: 'set', campo, valor }), []);
    const merge = useCallback((valores) => dispatch({ type: 'merge', valores }), []);
    const reset = useCallback((valores) => dispatch({ type: 'reset', valores }), []);
    const setVariavelTemplate = useCallback(
        (chave, valor) => dispatch({ type: 'setVariavelTemplate', chave, valor }),
        []
    );
    const setTipoEnvio = useCallback((valor) => dispatch({ type: 'setTipoEnvio', valor }), []);

    return { form, set, merge, reset, setVariavelTemplate, setTipoEnvio };
}

export { estadoInicial };
